import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useRouteHook } from '@shared/hooks';
import { RoutePaths } from '@shared/utils';
import { Button, Footer, Text } from '@shared/widgets';
import errorImg from '@assets/images/error-page.png';

export const ErrorPage = () => {
  const { pathname } = useLocation();
  const { navigate } = useRouteHook();

  useEffect(() => {
    if (pathname === '/signup') navigate(RoutePaths.dashboard.onNavigate());
  }, [pathname]);

  return (
    <>
      <div className='py-12 flex-auto flex flex-col text-center mt-[100px]'>
        <div className='m-auto'>
          <img className='max-w-[510px] mb-6' src={errorImg} alt='error' />
          <Text className='mb-6 font-[Prata]' size='5xl'>
            Everything is all right
          </Text>
          <Text weight='light' size='lg'>
            This page just doesn&apos;t exist yet
          </Text>
          <div className='mt-12'>
            <Button color='primary' to={RoutePaths.dashboard.onNavigate()}>
              Go back
            </Button>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
